export default __webpack_public_path__ + "static/media/science.ed802d50.png";